import React from 'react';
import PropTypes from 'prop-types';

class TableSeparator extends React.PureComponent {
	static propTypes = {
		handleMouseDown: PropTypes.func
	}

	static defaultProps = {
		handleMouseDown: null
	}

	render() {
		let enabled = false;
		const { handleMouseDown } = this.props;
		if (handleMouseDown) {
			enabled = true;
		}
		return (
			<div
				className={`h-4 w-3 ml-auto flex justify-center items-center ${
					enabled ? 'cursor-colResize' : ''
				}`}
				onMouseDown={handleMouseDown}>
				<div className="bg-white h-full" style={{ width: 1 }} />
			</div>
		);
	}
}

export default TableSeparator;
